import SuperUser from "../views/SuperUser/SuperUser";
import SuperDash from "../views/SuperUser/SuperDash";
import Teachers from "../views/SuperUser/Teachers";
import AdminStudents from "../views/SuperUser/Students";
import Programmes from "../views/SuperUser/Programmes";
import Classes from "../views/SuperUser/Classes";
import ClassOverview from "../views/SuperUser/ClassOverview";
import CoursesList from "../views/SuperUser/CoursesList";
import CourseModulesList from "../views/SuperUser/CourseModulesList";
import ModulesList from "../views/SuperUser/ModulesList";
import InvoiceHistory from "../views/SuperUser/InvoiceHistory";
import Users from "../views/SuperUser/Users";
//import SchoolLicense from "./views/SuperUser/SchoolLicense";
import ProgramLicenses from "../views/SuperUser/ProgramLicenses";
import Ratings from "../views/SuperUser/Ratings";
import NotificationsAdministration from "../views/SuperUser/NotificationsAdministration";
import LicMgtAdministration from "../views/SuperUser/LicMgtAdministration";

const navRoutesSuperuser = [
  { path: "/", exact: true, name: "Home", component: SuperDash },
  { path: "/superuser", exact: true, name: "Home", component: SuperDash },
  {
    path: "/superuser/schools",
    exact: true,
    name: "Schools",
    component: SuperUser,
  },
  {
    path: "/superuser/schools/teachers",
    exact: true,
    name: "Teachers",
    component: Teachers,
  },
  {
    path: "/superuser/schools/students",
    name: "Students",
    component: AdminStudents,
  },
  {
    path: "/superuser/schools/programmes",
    name: "Programmes",
    component: Programmes,
  },
  {
    path: "/superuser/schools/classes/classoverview",
    name: "ClassOverView",
    component: ClassOverview,
  },
  { path: "/superuser/schools/classes", name: "Classes", component: Classes },

  {
    path: "/superuser/courses",
    exact: true,
    name: "Courses",
    component: CoursesList,
  },
  {
    path: "/superuser/courses/coursemodules",
    name: "Coursemodules",
    component: CourseModulesList,
  },
  // {
  //   path: "/superuser/courses/licenses",
  //   name: "Licenses",
  //   component: SchoolLicense
  // },
  {
    path: "/superuser/courses/licenses",
    name: "Licenses",
    component: ProgramLicenses,
  },
  {
    path: "/superuser/courses/modules",
    name: "Modules",
    component: ModulesList,
  },
  {
    path: "/superuser/invoicehistory",
    name: "InvoiceHistory",
    component: InvoiceHistory,
  },
  {
    path: "/superuser/courses/ratings",
    name: "Ratings",
    component: Ratings,
  },
  { path: "/superuser/users", name: "Users", component: Users },
  {
    path: "/superuser/notifications",
    name: "NotificationsAdministration",
    component: NotificationsAdministration,
  },
  {
    path: "/superuser/licenses",
    name: "LicenseAdministration",
    component: LicMgtAdministration,
  },
];

export default navRoutesSuperuser;
